import {RemoteDeleteFavoriteDoctor} from 'data/usecases';
import {DeleteFavoriteDoctor} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {GuideFlowEndpoints} from 'main/factories/usecases/endpoints';

export const makeDeleteFavoriteDoctor = (): DeleteFavoriteDoctor =>
  new RemoteDeleteFavoriteDoctor(
    makeBFFApiUrl(GuideFlowEndpoints.medicalFavoriteDoctors),
    makeAuthorizeHttpClientDecorator(),
  );
